import { isCurrencyLike, normalizeCurrency } from '@/utils/currency';

function isValidCurrency(currencyValue) {
  return isCurrencyLike(currencyValue);
}

export default {
  namespaced: true,

  state: () => ({
    currency: null,
    request: null,
  }),

  getters: {
    currency(state) {
      return state.currency;
    },
  },

  mutations: {
    SET_CURRENCY(state, currency) {
      state.currency = currency || null;
    },
    SET_REQUEST(state, request) {
      state.request = request;
    },
    CLEAR_CURRENCY(state) {
      state.currency = null;
      state.request = null;
    },
  },

  actions: {
    async fetchCurrency({ state, commit, dispatch, rootState }, { force = false } = {}) {
      if (!force && state.currency) {
        return state.currency;
      }

      const merchantCurrency = normalizeCurrency(rootState?.login?.merchant?.currencySign);
      if (!force && isValidCurrency(merchantCurrency)) {
        commit('SET_CURRENCY', merchantCurrency);
        return merchantCurrency;
      }

      if (!force && state.request) {
        return state.request;
      }

      const request = Promise.resolve()
        .then(() => dispatch('get_merchant', undefined, { root: true }))
        .then(() => {
          const loadedCurrency = normalizeCurrency(rootState?.login?.merchant?.currencySign);
          if (!isValidCurrency(loadedCurrency) || loadedCurrency.error) {
            return loadedCurrency || null;
          }

          commit('SET_CURRENCY', loadedCurrency);
          commit('set_currencySign', loadedCurrency, { root: true });
          return loadedCurrency;
        })
        .catch((error) => {
          console.error('Error fetching merchant currency sign:', error);
          return { error };
        })
        .finally(() => {
          commit('SET_REQUEST', null);
        });

      commit('SET_REQUEST', request);

      return request;
    },

    setCurrency({ commit }, currency) {
      const normalizedCurrency = normalizeCurrency(currency);
      commit('SET_CURRENCY', normalizedCurrency);
      commit('set_currencySign', normalizedCurrency, { root: true });
    },

    clearCurrency({ commit }) {
      commit('CLEAR_CURRENCY');
    },
  },
};
